import { useTranslation } from 'react-i18next';
import { safeImageImport } from '../../core/helper/image.helper';
import { IInstanceInfo, IPreset, PresetId } from '../../core/interfaces/instaces.interfaces';
import './infoCard.style.scss';

export const InfoCard = (p: { instanceInfo: IInstanceInfo; onClick: (e?: PresetId) => unknown }) => {
  const { t } = useTranslation();
  const labelsSet = p.instanceInfo.labelsSet;

  return (
    <section className="InfoCardComponent">
      <div className="container">
        <div className="container__card container__card--big">
          <img
            className="container__logo"
            src={p.instanceInfo.presets[0]?.logo || safeImageImport(`assets/images/${p.instanceInfo.id}/loghi/logo-inline`)}
            alt="loquis-challenge-logo"
            width="220"
          />
          <h3 className="container__title" style={{ marginBottom: '20px' }}>
            {p.instanceInfo.presets[0]?.title || labelsSet?.tutorial?.title}
          </h3>
          <p className="container__card__text" style={(p.instanceInfo.presets[0]?.tagline || labelsSet?.tutorial?.tagline) ? { marginBottom: '20px' } : null}>
            {p.instanceInfo.presets[0]?.subtitle || labelsSet?.tutorial?.subtitle}
          </p>
          {(p.instanceInfo.presets[0]?.tagline || labelsSet?.tutorial?.tagline) && (
            <p
              className="container__card__text"
              dangerouslySetInnerHTML={{ __html: (p.instanceInfo.presets[0]?.tagline || labelsSet?.tutorial?.tagline || '').toString() }}
            ></p>
          )}
        </div>
        <hr className="divisor" />
        {p.instanceInfo.presets.map((preset: IPreset, idx: number) => (
          <div
            key={idx}
            className={
              'container__card container__card--little' +
              (p.instanceInfo.presets.length === 1 ? ' container__card--lonely' : '')
            }
          >
            <p className="container__card__text">
              <strong>{preset.maxQuestions}</strong> {t('tutorial.questions')}
            </p>
            <p className="container__card__text">
              <strong>{preset.options}</strong> {t('tutorial.ans-opt')}
            </p>
            <p className="container__card__text">
              <strong>{preset.userResponseTO}</strong> {t('tutorial.time')}
            </p>
            <p className="container__card__text">
              <strong>{preset.maxWrongQuestions}</strong> {t('tutorial.errors-opt')}
            </p>
            <button className={'basicButton' + (idx === 1 ? ' hard' : '')} onClick={() => p.onClick(preset.id)}>
              {t('tutorial.play')}
            </button>
          </div>
        ))}
      </div>
    </section>
  );
};
